import styled from '@emotion/styled';
import { useGlobal } from '../../hooks';
import { ReactNode } from 'react';

const FooterContainer = styled.div`
    height: var(--rwl-header-height);
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-top: 1px solid var(--rwl-color-neutral-border);
    container-type: inline-size;
    container-name: modal-footer;
`;

export const Footer = ({ children }: { children: ReactNode }) => {
    const { config } = useGlobal();
    if (!config) {
        return <FooterContainer />;
    }

    return <FooterContainer>{children}</FooterContainer>;
};
